__turbopack_context__.v({
  "clearButton": "SearchBar-module__9ObJ7W__clearButton",
  "form": "SearchBar-module__9ObJ7W__form",
  "input": "SearchBar-module__9ObJ7W__input",
  "inputContainer": "SearchBar-module__9ObJ7W__inputContainer",
  "pulse": "SearchBar-module__9ObJ7W__pulse",
  "searchBarFallback": "SearchBar-module__9ObJ7W__searchBarFallback",
});
